










import { Component, Mixins } from 'vue-property-decorator';
import TagSetPicker from '@/components/registration/common/tags/TagSetPicker.vue';
import { InterestsModel } from '@/interfaces/registration/models/InterestsModel';
import RegistrationPanelMixing from '@/mixins/registration/RegistrationPanelMixin';
import FieldMixin from '@/mixins/registration/FieldMixin';

@Component({
  components: { TagSetPicker }
})
export default class InterestsPanel extends Mixins(RegistrationPanelMixing, FieldMixin) {
  public model: InterestsModel = {};

  mounted () {
    this.$data.model = this.getPanelData('interests');

    window.scrollTo(0, 0);
  }

  public savePanelData (): Promise<boolean> {
    this.saveRegistrationModel({ data: this.model, model: 'interests' });
    return Promise.resolve(true);
  }

  get helpText (): string {
    return this.getCustomHelpText('Tag') || 'Sharing your interests helps us show you relevant content and make meaningful connections.';
  }

  get label (): string {
    return this.getCustomLabel('Tag') || 'So, what are you interested in?';
  }
}
